import React from 'react';
import Spot from './icons/commodities/Spot';
import XAUUSD from './icons/commodities/XAUUSD';
import Platinum from './icons/commodities/Platinum';
import USDSILVER from './icons/commodities/USDSILVER';
import ADAUSD from './icons/crypto/ADAUSD';
import BCHUSD from './icons/crypto/BCHUSD';
import BTCUSD from './icons/crypto/BTCUSD';
import DOTUSD from './icons/crypto/DOTUSD';
import DSHUSD from './icons/crypto/DSHUSD';
import ETHUSD from './icons/crypto/ETHUSD';
import LTCUSD from './icons/crypto/LTCUSD';
import XLMUSD from './icons/crypto/XLMUSD';
import XRMUSD from './icons/crypto/XRMUSD';
import XRPUSD from './icons/crypto/XRPUSD';
import AUDCAD from './icons/forex/AUDCAD';
import AUDCHF from './icons/forex/AUDCHF';
import AUDJPY from './icons/forex/AUDJPY';
import AUDNZD from './icons/forex/AUDNZD';
import AUDUSD from './icons/forex/AUDUSD';
import CADCHF from './icons/forex/CADCHF';
import CADJPY from './icons/forex/CADJPY';
import CHFJPY from './icons/forex/CHFJPY';
import EURAUD from './icons/forex/EURAUD';
import EURCAD from './icons/forex/EURCAD';
import EURCHF from './icons/forex/EURCHF';
import EURDKK from './icons/forex/EURDKK';
import EURGBP from './icons/forex/EURGBP';
import EURHUF from './icons/forex/EURHUF';
import EURJPY from './icons/forex/EURJPY';
import EURNOK from './icons/forex/EURNOK';
import EURNZD from './icons/forex/EURNZD';
import EURPLN from './icons/forex/EURPLN';
import EURTRY from './icons/forex/EURTRY';
import EURUSD from './icons/forex/EURUSD';
import GBPAUD from './icons/forex/GBPAUD';
import GBPCAD from './icons/forex/GBPCAD';
import GBPCHF from './icons/forex/GBPCHF';
import GBPJPY from './icons/forex/GBPJPY';
import GBPNZD from './icons/forex/GBPNZD';
import GBPUSD from './icons/forex/GBPUSD';
import NZDCAD from './icons/forex/NZDCAD';
import NZDCHF from './icons/forex/NZDCHF';
import NZDJPY from './icons/forex/NZDJPY';
import NZDUSD from './icons/forex/NZDUSD';
import SGDJPY from './icons/forex/SGDJPY';
import USDCAD from './icons/forex/USDCAD';
import USDCHF from './icons/forex/USDCHF';
import USDDKK from './icons/forex/USDDKK';
import USDHKD from './icons/forex/USDHKD';
import USDHUF from './icons/forex/USDHUF';
import USDJPY from './icons/forex/USDJPY';
import USDMXN from './icons/forex/USDMXN';
import USDPLN from './icons/forex/USDPLN';
import USDSEK from './icons/forex/USDSEK';
import USDSGD from './icons/forex/USDSGD';
import USDTRY from './icons/forex/USDTRY';
import USDZAR from './icons/forex/USDZAR';
import AAPL from './icons/stocks/AAPL';
import ABBV from './icons/stocks/ABBV';
import ABNB from './icons/stocks/ABNB';
import ADBE from './icons/stocks/ADBE';
import AMAT from './icons/stocks/AMAT';
import AMD from './icons/stocks/AMD';
import AMGN from './icons/stocks/AMGN';
import AMZN from './icons/stocks/AMZN';
import ASML from './icons/stocks/ASML';
import AXP from './icons/stocks/AXP';
import BA from './icons/stocks/BA';
import BABA from './icons/stocks/BABA';
import BAC from './icons/stocks/BAC';
import BLK from './icons/stocks/BLK';
import BRKB from './icons/stocks/BRKB';
import C from './icons/stocks/C';
import CAT from './icons/stocks/CAT';
import COIN from './icons/stocks/COIN';
import COST from './icons/stocks/COST';
import CRM from './icons/stocks/CRM';
import CSCO from './icons/stocks/CSCO';
import CVX from './icons/stocks/CVX';
import DE from './icons/stocks/DE';
import GE from './icons/stocks/GE';
import GME from './icons/stocks/GME';
import GOOGL from './icons/stocks/GOOGL';
import GS from './icons/stocks/GS';
import HD from './icons/stocks/HD';
import HON from './icons/stocks/HON';
import HSBC from './icons/stocks/HSBC';
import INTC from './icons/stocks/INTC';
import JNJ from './icons/stocks/JNJ';
import JPM from './icons/stocks/JPM';
import KO from './icons/stocks/KO';
import LMT from './icons/stocks/LMT';
import LYFT from './icons/stocks/LYFT';
import MA from './icons/stocks/MA';
import MCD from './icons/stocks/MCD';
import META from './icons/stocks/META';
import MMM from './icons/stocks/MMM';
import MRK from './icons/stocks/MRK';
import MS from './icons/stocks/MS';
import MSFT from './icons/stocks/MSFT';
import MU from './icons/stocks/MU';
import NFLX from './icons/stocks/NFLX';
import NKE from './icons/stocks/NKE';
import NVDA from './icons/stocks/NVDA';
import NVO from './icons/stocks/NVO';
import ORCL from './icons/stocks/ORCL';
import PANW from './icons/stocks/PANW';
import PEP from './icons/stocks/PEP';
import PFE from './icons/stocks/PFE';
import PG from './icons/stocks/PG';
import PYPL from './icons/stocks/PYPL';
import QCOM from './icons/stocks/QCOM';
import RBLX from './icons/stocks/RBLX';
import RIVN from './icons/stocks/RIVN';
import SAP from './icons/stocks/SAP';
import SBUX from './icons/stocks/SBUX';
import SHOP from './icons/stocks/SHOP';
import SNAP from './icons/stocks/SNAP';
import SONY from './icons/stocks/SONY';
import TM from './icons/stocks/TM';
import TSLA from './icons/stocks/TSLA';
import TSM from './icons/stocks/TSM';
import TWTR from './icons/stocks/TWTR';
import UBER from './icons/stocks/UBER';
import UNH from './icons/stocks/UNH';
import V from './icons/stocks/V';
import VZ from './icons/stocks/VZ';
import WFC from './icons/stocks/WFC';
import WMT from './icons/stocks/WMT';
import _1INCH from './icons/coins/_1INCH';
import _1INCHBSC from './icons/coins/_1INCHBSC';
import AAVE from './icons/coins/AAVE';
import ADA from './icons/coins/ADA';
import AE from './icons/coins/AE';
import AITECH from './icons/coins/AITECH';
import ALGO from './icons/coins/ALGO';
import APEERC20 from './icons/coins/APEERC20';
import APT from './icons/coins/APT';
import ARB from './icons/coins/ARB';
import ARK from './icons/coins/ARK';
import ARPAERC20 from './icons/coins/ARPAERC20';
import ARV from './icons/coins/ARV';
import ATOM from './icons/coins/ATOM';
import AVA from './icons/coins/AVA';
import AVABSC from './icons/coins/AVABSC';
import AVAERC20 from './icons/coins/AVAERC20';
import AVAX from './icons/coins/AVAX';
import AVN from './icons/coins/AVN';
import AXS from './icons/coins/AXS';
import BABYDOGE from './icons/coins/BABYDOGE';
import BANANA from './icons/coins/BANANA';
import BAT from './icons/coins/BAT';
import BAZED from './icons/coins/BAZED';
import BCD from './icons/coins/BCD';
import BCH from './icons/coins/BCH';
import BEAM from './icons/coins/BEAM';
import BEFI from './icons/coins/BEFI';
import BELERC20 from './icons/coins/BELERC20';
import BIFIBSC from './icons/coins/BIFIBSC';
import BLOCKS from './icons/coins/BLOCKS';
import BNBBSC from './icons/coins/BNBBSC';
import BOBA from './icons/coins/BOBA';
import BONE from './icons/coins/BONE';
import BRETT from './icons/coins/BRETT';
import BRGBSC from './icons/coins/BRGBSC';
import BRISEBSC from './icons/coins/BRISEBSC';
import BRISEMAINNET from './icons/coins/BRISEMAINNET';
import BSV from './icons/coins/BSV';
import BTC from './icons/coins/BTC';
import BTFA from './icons/coins/BTFA';
import BTG from './icons/coins/BTG';
import BTTBSC from './icons/coins/BTTBSC';
import BTTC from './icons/coins/BTTC';
import BTTTRC20 from './icons/coins/BTTTRC20';
import BUSD from './icons/coins/BUSD';
import C98 from './icons/coins/C98';
import CAKE from './icons/coins/CAKE';
import CATI from './icons/coins/CATI';
import CATSTON from './icons/coins/CATSTON';
import CFXBSC from './icons/coins/CFXBSC';
import CGPT from './icons/coins/CGPT';
import CGPTBSC from './icons/coins/CGPTBSC';
import CHR from './icons/coins/CHR';
import CHZ from './icons/coins/CHZ';
import CNS from './icons/coins/CNS';
import COTI from './icons/coins/COTI';
import CRO from './icons/coins/CRO';
import CSPR from './icons/coins/CSPR';
import CSWAP from './icons/coins/CSWAP';
import CTSI from './icons/coins/CTSI';
import CUDOSERC20 from './icons/coins/CUDOSERC20';
import CULT from './icons/coins/CULT';
import CVC from './icons/coins/CVC';
import DADDY from './icons/coins/DADDY';
import DAI from './icons/coins/DAI';
import DAO from './icons/coins/DAO';
import DASH from './icons/coins/DASH';
import DCR from './icons/coins/DCR';
import DGB from './icons/coins/DGB';
import DGD from './icons/coins/DGD';
import DGI from './icons/coins/DGI';
import DGMOON from './icons/coins/DGMOON';
import DINO from './icons/coins/DINO';
import DIVI from './icons/coins/DIVI';
import DOGE from './icons/coins/DOGE';
import DOGECOINBSC from './icons/coins/DOGECOINBSC';
import DOGS from './icons/coins/DOGS';
import DOT from './icons/coins/DOT';
import EGLD from './icons/coins/EGLD';
import ENJ from './icons/coins/ENJ';
import EOS from './icons/coins/EOS';
import EPIC from './icons/coins/EPIC';
import ETC from './icons/coins/ETC';
import ETH from './icons/coins/ETH';
import ETHARB from './icons/coins/ETHARB';
import ETHBSC from './icons/coins/ETHBSC';
import ETHW from './icons/coins/ETHW';
import EURT from './icons/coins/EURT';
import FEG from './icons/coins/FEG';
import FILMAINNET from './icons/coins/FILMAINNET';
import FIRO from './icons/coins/FIRO';
import FITFIARC20 from './icons/coins/FITFIARC20';
import FLOKI from './icons/coins/FLOKI';
import FLOKIBSC from './icons/coins/FLOKIBSC';
import FLUFBSC from './icons/coins/FLUFBSC';
import FRONT from './icons/coins/FRONT';
import FTM from './icons/coins/FTM';
import FTN from './icons/coins/FTN';
import FTT from './icons/coins/FTT';
import FUN from './icons/coins/FUN';
import GAFABSC from './icons/coins/GAFABSC';
import GALA from './icons/coins/GALA';
import GALBSC from './icons/coins/GALBSC';
import GARI from './icons/coins/GARI';
import GASNEO from './icons/coins/GASNEO';
import GBSC from './icons/coins/GBSC';
import GERC20 from './icons/coins/GERC20';
import GETH from './icons/coins/GETH';
import GGTKN from './icons/coins/GGTKN';
import GHC from './icons/coins/GHC';
import GRAPECOIN from './icons/coins/GRAPECOIN';
import GRS from './icons/coins/GRS';
import GRTERC20 from './icons/coins/GRTERC20';
import GSPI from './icons/coins/GSPI';
import GTERC20 from './icons/coins/GTERC20';
import GUARDBSC from './icons/coins/GUARDBSC';
import GUSD from './icons/coins/GUSD';
import HBAR from './icons/coins/HBAR';
import HEX from './icons/coins/HEX';
import HMSTR from './icons/coins/HMSTR';
import HOGE from './icons/coins/HOGE';
import HOTCROSS from './icons/coins/HOTCROSS';
import HOTTOKEN from './icons/coins/HOTTOKEN';
import HT from './icons/coins/HT';
import ICX from './icons/coins/ICX';
import ILV from './icons/coins/ILV';
import INJ from './icons/coins/INJ';
import IOTX from './icons/coins/IOTX';
import IPMB from './icons/coins/IPMB';
import JASMY from './icons/coins/JASMY';
import JETTON from './icons/coins/JETTON';
import JST from './icons/coins/JST';
import KAS from './icons/coins/KAS';
import KEANU from './icons/coins/KEANU';
import KIBA from './icons/coins/KIBA';
import KIBABSC from './icons/coins/KIBABSC';
import KISHU from './icons/coins/KISHU';
import KLAY from './icons/coins/KLAY';
import KLV from './icons/coins/KLV';
import KMD from './icons/coins/KMD';
import KNC from './icons/coins/KNC';
import LBP from './icons/coins/LBP';
import LEASH from './icons/coins/LEASH';
import LGCY from './icons/coins/LGCY';
import LINK from './icons/coins/LINK';
import LNQ from './icons/coins/LNQ';
import LSK from './icons/coins/LSK';
import LTC from './icons/coins/LTC';
import LUNA from './icons/coins/LUNA';
import LUNC from './icons/coins/LUNC';
import MANA from './icons/coins/MANA';
import MARSH from './icons/coins/MARSH';
import MATIC from './icons/coins/MATIC';
import MATICMAINNET from './icons/coins/MATICMAINNET';
import MATICUSDCE from './icons/coins/MATICUSDCE';
import MCO from './icons/coins/MCO';
import MEW from './icons/coins/MEW';
import MIOTA from './icons/coins/MIOTA';
import MXTOKEN from './icons/coins/MXTOKEN';
import MYRO from './icons/coins/MYRO';
import NEAR from './icons/coins/NEAR';
import NEIROERC20 from './icons/coins/NEIROERC20';
import NEO from './icons/coins/NEO';
import NEVER from './icons/coins/NEVER';
import NFAI from './icons/coins/NFAI';
import NFTB from './icons/coins/NFTB';
import NOTCOIN from './icons/coins/NOTCOIN';
import NOW from './icons/coins/NOW';
import NPXS from './icons/coins/NPXS';
import NTVRK from './icons/coins/NTVRK';
import NWC from './icons/coins/NWC';
import OCEAN from './icons/coins/OCEAN';
import OKB from './icons/coins/OKB';
import OMCOIN from './icons/coins/OMCOIN';
import OMG from './icons/coins/OMG';
import ONE from './icons/coins/ONE';
import ONIGIERC20 from './icons/coins/ONIGIERC20';
import ONT from './icons/coins/ONT';
import PEIPEI from './icons/coins/PEIPEI';
import PENG from './icons/coins/PENG';
import PEW from './icons/coins/PEW';
import PIKAETH from './icons/coins/PIKAETH';
import PIT from './icons/coins/PIT';
import PIVX from './icons/coins/PIVX';
import PLS from './icons/coins/PLS';
import PLX from './icons/coins/PLX';
import PONKE from './icons/coins/PONKE';
import POODL from './icons/coins/POODL';
import POOLX from './icons/coins/POOLX';
import POOLZ from './icons/coins/POOLZ';
import PYUSD from './icons/coins/PYUSD';
import QTUM from './icons/coins/QTUM';
import QUACKBSC from './icons/coins/QUACKBSC';
import RACA from './icons/coins/RACA';
import RAINCOIN from './icons/coins/RAINCOIN';
import RBIF from './icons/coins/RBIF';
import REP from './icons/coins/REP';
import RJVBSC from './icons/coins/RJVBSC';
import RJVERC20 from './icons/coins/RJVERC20';
import RUNE from './icons/coins/RUNE';
import RVN from './icons/coins/RVN';
import RXCG from './icons/coins/RXCG';
import SAND from './icons/coins/SAND';
import SCRAT from './icons/coins/SCRAT';
import SCRT from './icons/coins/SCRT';
import SEI from './icons/coins/SEI';
import SFUNDBSC from './icons/coins/SFUNDBSC';
import SHIB from './icons/coins/SHIB';
import SHIBBSC from './icons/coins/SHIBBSC';
import SIDUS from './icons/coins/SIDUS';
import SNSY from './icons/coins/SNSY';
import SOL from './icons/coins/SOL';
import SOON from './icons/coins/SOON';
import SPACEID from './icons/coins/SPACEID';
import SPI from './icons/coins/SPI';
import SRK from './icons/coins/SRK';
import STKK from './icons/coins/STKK';
import STPT from './icons/coins/STPT';
import STRAX from './icons/coins/STRAX';
import STRK from './icons/coins/STRK';
import SUNCOIN from './icons/coins/SUNCOIN';
import SUNDOG from './icons/coins/SUNDOG';
import SUPERFARM from './icons/coins/SUPERFARM';
import SXP from './icons/coins/SXP';
import SYSEVM from './icons/coins/SYSEVM';
import TENSHI from './icons/coins/TENSHI';
import TET from './icons/coins/TET';
import TFUEL from './icons/coins/TFUEL';
import THETA from './icons/coins/THETA';
import TKO from './icons/coins/TKO';
import TLOS from './icons/coins/TLOS';
import TOMOERC20 from './icons/coins/TOMOERC20';
import TON from './icons/coins/TON';
import TRVL from './icons/coins/TRVL';
import TRX from './icons/coins/TRX';
import TTCBSC from './icons/coins/TTCBSC';
import TUP from './icons/coins/TUP';
import TUSD from './icons/coins/TUSD';
import TUSDTRC20 from './icons/coins/TUSDTRC20';
import UNI from './icons/coins/UNI';
import USDC from './icons/coins/USDC';
import USDCMATIC from './icons/coins/USDCMATIC';
import USDCSOL from './icons/coins/USDCSOL';
import USDDTRC20 from './icons/coins/USDDTRC20';
import USDE from './icons/coins/USDE';
import USDJ from './icons/coins/USDJ';
import USDP from './icons/coins/USDP';
import USDT from './icons/coins/USDT';
import USDTBSC from './icons/coins/USDTBSC';
import USDTERC20 from './icons/coins/USDTERC20';
import USDTMATIC from './icons/coins/USDTMATIC';
import USDTSOL from './icons/coins/USDTSOL';
import USDTTRC20 from './icons/coins/USDTTRC20';
import UST from './icons/coins/UST';
import VELO from './icons/coins/VELO';
import VERSE from './icons/coins/VERSE';
import VET from './icons/coins/VET';
import VIB from './icons/coins/VIB';
import VOLT from './icons/coins/VOLT';
import VPSAI from './icons/coins/VPSAI';
import WABI from './icons/coins/WABI';
import WAVES from './icons/coins/WAVES';
import WBTCMATIC from './icons/coins/WBTCMATIC';
import WIN from './icons/coins/WIN';
import WOLF from './icons/coins/WOLF';
import XAUT from './icons/coins/XAUT';
import XCADERC20 from './icons/coins/XCADERC20';
import XCUR from './icons/coins/XCUR';
import XDC from './icons/coins/XDC';
import XEC from './icons/coins/XEC';
import XEM from './icons/coins/XEM';
import XEMPIRE from './icons/coins/XEMPIRE';
import XLM from './icons/coins/XLM';
import XMR from './icons/coins/XMR';
import XNO from './icons/coins/XNO';
import XRP from './icons/coins/XRP';
import XTZ from './icons/coins/XTZ';
import XVG from './icons/coins/XVG';
import XYM from './icons/coins/XYM';
import XYOERC20 from './icons/coins/XYOERC20';
import XZC from './icons/coins/XZC';
import YFI from './icons/coins/YFI';
import ZBCSOL from './icons/coins/ZBCSOL';
import ZEC from './icons/coins/ZEC';
import ZEN from './icons/coins/ZEN';
import ZENT from './icons/coins/ZENT';
import ZIL from './icons/coins/ZIL';
import ZKTOKEN from './icons/coins/ZKTOKEN';
import ZROARB from './icons/coins/ZROARB';
import ZROERC from './icons/coins/ZROERC';
import { IconProps } from './icons/types/types';

const icons: { [key: string]: React.FC<IconProps> } = {
    'audcad': AUDCAD,
    'audchf': AUDCHF,
    'audjpy': AUDJPY,
    'audnzd': AUDNZD,
    'audusd': AUDUSD,
    'cadchf': CADCHF,
    'cadjpy': CADJPY,
    'chfjpy': CHFJPY,
    'euraud': EURAUD,
    'eurcad': EURCAD,
    'eurchf': EURCHF,
    'eurdkk': EURDKK,
    'eurgbp': EURGBP,
    'eurhuf': EURHUF,
    'eurjpy': EURJPY,
    'eurnok': EURNOK,
    'eurnzd': EURNZD,
    'eurpln': EURPLN,
    'eurtry': EURTRY,
    'eurusd': EURUSD,
    'gbpaud': GBPAUD,
    'gbpcad': GBPCAD,
    'gbpchf': GBPCHF,
    'gbpjpy': GBPJPY,
    'gbpnzd': GBPNZD,
    'gbpusd': GBPUSD,
    'nzdcad': NZDCAD,
    'nzdchf': NZDCHF,
    'nzdjpy': NZDJPY,
    'nzdusd': NZDUSD,
    'sgdjpy': SGDJPY,
    'usdcad': USDCAD,
    'usdchf': USDCHF,
    'usddkk': USDDKK,
    'usdhkd': USDHKD,
    'usdhuf': USDHUF,
    'usdjpy': USDJPY,
    'usdmxn': USDMXN,
    'usdpln': USDPLN,
    'usdsek': USDSEK,
    'usdsgd': USDSGD,
    'usdtry': USDTRY,
    'usdzar': USDZAR,
    // ========= End Of Forex Pairs =========
    'adausd': ADAUSD,
    'bchusd': BCHUSD,
    'btcusd': BTCUSD,
    'dotusd': DOTUSD,
    'dshusd': DSHUSD,
    'ethusd': ETHUSD,
    'ltcusd': LTCUSD,
    'xlmusd': XLMUSD,
    'xrmusd': XRMUSD,
    'xrpusd': XRPUSD,
    // ========= End Of Crypto Pairs =========
    'platinum': Platinum,
    'spot': Spot,
    'usdsilver': USDSILVER, 'xauusd': XAUUSD,
    // ========= End Of Commodities =========
    'aapl': AAPL,
    'abbv': ABBV,
    'abnb': ABNB,
    'adbe': ADBE,
    'amat': AMAT,
    'amd': AMD,
    'amgn': AMGN,
    'amzn': AMZN,
    'asml': ASML,
    'axp': AXP,
    'ba': BA,
    'baba': BABA,
    'bac': BAC,
    'blk': BLK,
    'brkb': BRKB,
    'c': C,
    'cat': CAT,
    'coin': COIN,
    'cost': COST,
    'crm': CRM,
    'csco': CSCO,
    'cvx': CVX,
    'de': DE,
    'ge': GE,
    'gme': GME,
    'googl': GOOGL,
    'gs': GS,
    'hd': HD,
    'hon': HON,
    'hsbc': HSBC,
    'intc': INTC,
    'jnj': JNJ,
    'jpm': JPM,
    'ko': KO,
    'lmt': LMT,
    'lyft': LYFT,
    'ma': MA,
    'mcd': MCD,
    'meta': META,
    'mmm': MMM,
    'mrk': MRK,
    'ms': MS,
    'msft': MSFT,
    'mu': MU,
    'nflx': NFLX,
    'nke': NKE,
    'nvda': NVDA,
    'nvo': NVO,
    'orcl': ORCL,
    'panw': PANW,
    'pep': PEP,
    'pfe': PFE,
    'pg': PG,
    'pypl': PYPL,
    'qcom': QCOM,
    'rblx': RBLX,
    'rivn': RIVN,
    'sap': SAP,
    'sbux': SBUX,
    'shop': SHOP,
    'snap': SNAP,
    'sony': SONY,
    'tm': TM,
    'tsla': TSLA,
    'tsm': TSM,
    'twtr': TWTR,
    'uber': UBER,
    'unh': UNH,
    'v': V,
    'vz': VZ,
    'wfc': WFC,
    'wmt': WMT,
    // ========= End Of Stocks =========
    '1inch': _1INCH,
    '1inchbsc': _1INCHBSC,
    'aave': AAVE,
    'ada': ADA,
    'ae': AE,
    'aitech': AITECH,
    'algo': ALGO,
    'apeerc20': APEERC20,
    'apt': APT,
    'arb': ARB,
    'ark': ARK,
    'arpaerc20': ARPAERC20,
    'arv': ARV,
    'atom': ATOM,
    'ava': AVA,
    'avabsc': AVABSC,
    'avaerc20': AVAERC20,
    'avax': AVAX,
    'avn': AVN,
    'axs': AXS,
    'babydoge': BABYDOGE,
    'banana': BANANA,
    'bat': BAT,
    'bazed': BAZED,
    'bcd': BCD,
    'bch': BCH,
    'beam': BEAM,
    'befi': BEFI,
    'belerc20': BELERC20,
    'bifibsc': BIFIBSC,
    'blocks': BLOCKS,
    'bnbbsc': BNBBSC,
    'boba': BOBA,
    'bone': BONE,
    'brett': BRETT,
    'brgbsc': BRGBSC,
    'brisebsc': BRISEBSC,
    'brisemainnet': BRISEMAINNET,
    'bsv': BSV,
    'btc': BTC,
    'btfa': BTFA,
    'btg': BTG,
    'bttbsc': BTTBSC,
    'bttc': BTTC,
    'btttrc20': BTTTRC20,
    'busd': BUSD,
    'c98': C98,
    'cake': CAKE,
    'cati': CATI,
    'catston': CATSTON,
    'cfxbsc': CFXBSC,
    'cgpt': CGPT,
    'cgptbsc': CGPTBSC,
    'chr': CHR,
    'chz': CHZ,
    'cns': CNS,
    'coti': COTI,
    'cro': CRO,
    'cspr': CSPR,
    'cswap': CSWAP,
    'ctsi': CTSI,
    'cudoserc20': CUDOSERC20,
    'cult': CULT,
    'cvc': CVC,
    'daddy': DADDY,
    'dai': DAI,
    'dao': DAO,
    'dash': DASH,
    'dcr': DCR,
    'dgb': DGB,
    'dgd': DGD,
    'dgi': DGI,
    'dgmoon': DGMOON,
    'dino': DINO,
    'divi': DIVI,
    'doge': DOGE,
    'dogecoin': DOGECOINBSC,
    'dogs': DOGS,
    'dot': DOT,
    'egld': EGLD,
    'enj': ENJ,
    'eos': EOS,
    'epic': EPIC,
    'etc': ETC,
    'eth': ETH,
    'etharb': ETHARB,
    'ethbsc': ETHBSC,
    'ethw': ETHW,
    'eurt': EURT,
    'feg': FEG,
    'filmainnet': FILMAINNET,
    'firo': FIRO,
    'fitfiarc20': FITFIARC20,
    'floki': FLOKI,
    'flokibsc': FLOKIBSC,
    'flufbsc': FLUFBSC,
    'front': FRONT,
    'ftm': FTM,
    'ftn': FTN,
    'ftt': FTT,
    'fun': FUN,
    'gafabsc': GAFABSC,
    'gala': GALA,
    'galbsc': GALBSC,
    'gari': GARI,
    'gas': GASNEO,
    'gbsc': GBSC,
    'gerc20': GERC20,
    'geth': GETH,
    'ggtkn': GGTKN,
    'ghc': GHC,
    'grapecoin': GRAPECOIN,
    'grs': GRS,
    'grterc20': GRTERC20,
    'gspi': GSPI,
    'gterc20': GTERC20,
    'guardbsc': GUARDBSC,
    'gusd': GUSD,
    'hbar': HBAR,
    'hex': HEX,
    'hmstr': HMSTR,
    'hoge': HOGE,
    'hotcross': HOTCROSS,
    'hot': HOTTOKEN,
    'ht': HT,
    'icx': ICX,
    'ilv': ILV,
    'inj': INJ,
    'iotx': IOTX,
    'ipmb': IPMB,
    'jasmy': JASMY,
    'jetton': JETTON,
    'jst': JST,
    'kas': KAS,
    'keanu': KEANU,
    'kiba': KIBA,
    'kibabsc': KIBABSC,
    'kishu': KISHU,
    'klay': KLAY,
    'klv': KLV,
    'kmd': KMD,
    'knc': KNC,
    'lbp': LBP,
    'leash': LEASH,
    'lgcy': LGCY,
    'link': LINK,
    'lnq': LNQ,
    'lsk': LSK,
    'ltc': LTC,
    'luna': LUNA,
    'lunc': LUNC,
    'mana': MANA,
    'marsh': MARSH,
    'matic': MATIC,
    'maticmainnet': MATICMAINNET,
    'maticusdce': MATICUSDCE,
    'mco': MCO,
    'mew': MEW,
    'miota': MIOTA,
    'mx': MXTOKEN,
    'myro': MYRO,
    'near': NEAR,
    'neiroerc20': NEIROERC20,
    'neo': NEO,
    'never': NEVER,
    'nfai': NFAI,
    'nftb': NFTB,
    'not': NOTCOIN,
    'now': NOW,
    'npxs': NPXS,
    'ntvrk': NTVRK,
    'nwc': NWC,
    'ocean': OCEAN,
    'okb': OKB,
    'om': OMCOIN,
    'omg': OMG,
    'one': ONE,
    'onigierc20': ONIGIERC20,
    'ont': ONT,
    'peipei': PEIPEI,
    'peng': PENG,
    'pew': PEW,
    'pikaeth': PIKAETH,
    'pit': PIT,
    'pivx': PIVX,
    'pls': PLS,
    'plx': PLX,
    'ponke': PONKE,
    'poodl': POODL,
    'poolx': POOLX,
    'poolz': POOLZ,
    'pyusd': PYUSD,
    'qtum': QTUM,
    'quackbsc': QUACKBSC,
    'raca': RACA,
    'raincoin': RAINCOIN,
    'rbif': RBIF,
    'rep': REP,
    'rjvbsc': RJVBSC,
    'rjverc20': RJVERC20,
    'rune': RUNE,
    'rvn': RVN,
    'rxcg': RXCG,
    'sand': SAND,
    'scrat': SCRAT,
    'scrt': SCRT,
    'sei': SEI,
    'sfundbsc': SFUNDBSC,
    'shib': SHIB,
    'shibbsc': SHIBBSC,
    'sidus': SIDUS,
    'snsy': SNSY,
    'sol': SOL,
    'soon': SOON,
    'id': SPACEID,
    'spi': SPI,
    'srk': SRK,
    'stkk': STKK,
    'stpt': STPT,
    'strax': STRAX,
    'strk': STRK,
    'sun': SUNCOIN,
    'sundog': SUNDOG,
    'super': SUPERFARM,
    'sxp': SXP,
    'sysevm': SYSEVM,
    'tenshi': TENSHI,
    'tet': TET,
    'tfuel': TFUEL,
    'theta': THETA,
    'tko': TKO,
    'tlos': TLOS,
    'tomoerc20': TOMOERC20,
    'ton': TON,
    'trvl': TRVL,
    'trx': TRX,
    'ttcbsc': TTCBSC,
    'tup': TUP,
    'tusd': TUSD,
    'tusdtrc20': TUSDTRC20,
    'uni': UNI,
    'usdc': USDC,
    'usdcmatic': USDCMATIC,
    'usdcsol': USDCSOL,
    'usddtrc20': USDDTRC20,
    'usde': USDE,
    'usdj': USDJ,
    'usdp': USDP,
    'usdt': USDT,
    'usdtbsc': USDTBSC,
    'usdterc20': USDTERC20,
    'usdtmatic': USDTMATIC,
    'usdtsol': USDTSOL,
    'usdttrc20': USDTTRC20,
    'ust': UST,
    'velo': VELO,
    'verse': VERSE,
    'vet': VET,
    'vib': VIB,
    'volt': VOLT,
    'vpsai': VPSAI,
    'wabi': WABI,
    'waves': WAVES,
    'wbtcmatic': WBTCMATIC,
    'win': WIN,
    'wolf': WOLF,
    'xaut': XAUT,
    'xcaderc20': XCADERC20,
    'xcur': XCUR,
    'xdc': XDC,
    'xec': XEC,
    'xem': XEM,
    'x': XEMPIRE,
    'xlm': XLM,
    'xmr': XMR,
    'xno': XNO,
    'xrp': XRP,
    'xtz': XTZ,
    'xvg': XVG,
    'xym': XYM,
    'xyoerc20': XYOERC20,
    'xzc': XZC,
    'yfi': YFI,
    'zbcsol': ZBCSOL,
    'zec': ZEC,
    'zen': ZEN,
    'zent': ZENT,
    'zil': ZIL,
    'zk': ZKTOKEN,
    'zroarb': ZROARB,
    'zroerc': ZROERC,
    // ========= End Of Coins =========
}

export interface Props {
    icon: string;
    className?: string;
    style?: React.CSSProperties;
}

const Avatar: React.FC<{ label: string; className?: string; style?: React.CSSProperties }> = ({ label, className, style }) => {
    const text = label.slice(0, 3).toUpperCase();
    return (
        <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" role="img" className={className} style={style}>
            <rect width="40" height="40" rx="20" fill="#6B7280" />
            <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" fill="#ffffff" fontSize={text.length > 2 ? "11" : "13"} fontFamily="sans-serif" fontWeight="bold">
                {text}
            </text>
        </svg>
    );
};

const FinancialFlagIcon: React.FC<Props> = props => {
    const IconComponent = icons[props.icon.toLowerCase()];
    return IconComponent
        ? <IconComponent className={props.className} style={props.style} />
        : <Avatar label={props.icon} className={props.className} style={props.style} />;
}

export default FinancialFlagIcon;

// ── Named exports ─────────────────────────────────────────────────────────────
// Import individual icons for tree-shakeable usage:
//   import { BTC, EURUSD, AAPL } from 'financial-flag-icons';
//   <BTC className="w-8 h-8" />

// Commodities
export { Spot, XAUUSD, Platinum, USDSILVER };

// Crypto pairs (legacy)
export { ADAUSD, BCHUSD, BTCUSD, DOTUSD, DSHUSD, ETHUSD, LTCUSD, XLMUSD, XRMUSD, XRPUSD };

// Forex
export {
    AUDCAD, AUDCHF, AUDJPY, AUDNZD, AUDUSD,
    CADCHF, CADJPY, CHFJPY,
    EURAUD, EURCAD, EURCHF, EURDKK, EURGBP, EURHUF, EURJPY, EURNOK, EURNZD, EURPLN, EURTRY, EURUSD,
    GBPAUD, GBPCAD, GBPCHF, GBPJPY, GBPNZD, GBPUSD,
    NZDCAD, NZDCHF, NZDJPY, NZDUSD,
    SGDJPY,
    USDCAD, USDCHF, USDDKK, USDHKD, USDHUF, USDJPY, USDMXN, USDPLN, USDSEK, USDSGD, USDTRY, USDZAR,
};

// Stocks
export {
    AAPL, ABBV, ABNB, ADBE, AMAT, AMD, AMGN, AMZN, ASML, AXP,
    BA, BABA, BAC, BLK, BRKB,
    C, CAT, COIN, COST, CRM, CSCO, CVX,
    DE, GE, GME, GOOGL, GS, HD, HON, HSBC, INTC, JNJ, JPM, KO, LMT, LYFT,
    MA, MCD, META, MMM, MRK, MS, MSFT, MU, NFLX, NKE, NVDA, NVO,
    ORCL, PANW, PEP, PFE, PG, PYPL, QCOM, RBLX, RIVN,
    SAP, SBUX, SHOP, SNAP, SONY, TM, TSLA, TSM, TWTR, UBER, UNH, V, VZ, WFC, WMT,
};

// Crypto coins
export {
    _1INCH, _1INCHBSC, AAVE, ADA, AE, AITECH, ALGO, APEERC20, APT, ARB, ARK, ARPAERC20, ARV, ATOM,
    AVA, AVABSC, AVAERC20, AVAX, AVN, AXS,
    BABYDOGE, BANANA, BAT, BAZED, BCD, BCH, BEAM, BEFI, BELERC20, BIFIBSC, BLOCKS, BNBBSC, BOBA,
    BONE, BRETT, BRGBSC, BRISEBSC, BRISEMAINNET, BSV, BTC, BTFA, BTG, BTTBSC, BTTC, BTTTRC20, BUSD,
    C98, CAKE, CATI, CATSTON, CFXBSC, CGPT, CGPTBSC, CHR, CHZ, CNS, COTI, CRO, CSPR, CSWAP, CTSI,
    CUDOSERC20, CULT, CVC, DADDY, DAI, DAO, DASH, DCR, DGB, DGD, DGI, DGMOON, DINO, DIVI, DOGE,
    DOGECOINBSC, DOGS, DOT, EGLD, ENJ, EOS, EPIC, ETC, ETH, ETHARB, ETHBSC, ETHW, EURT,
    FEG, FILMAINNET, FIRO, FITFIARC20, FLOKI, FLOKIBSC, FLUFBSC, FRONT, FTM, FTN, FTT, FUN,
    GAFABSC, GALA, GALBSC, GARI, GASNEO, GBSC, GERC20, GETH, GGTKN, GHC, GRAPECOIN, GRS,
    GRTERC20, GSPI, GTERC20, GUARDBSC, GUSD,
    HBAR, HEX, HMSTR, HOGE, HOTCROSS, HOTTOKEN, HT,
    ICX, ILV, INJ, IOTX, IPMB, JASMY, JETTON, JST,
    KAS, KEANU, KIBA, KIBABSC, KISHU, KLAY, KLV, KMD, KNC,
    LBP, LEASH, LGCY, LINK, LNQ, LSK, LTC, LUNA, LUNC,
    MANA, MARSH, MATIC, MATICMAINNET, MATICUSDCE, MCO, MEW, MIOTA, MXTOKEN, MYRO,
    NEAR, NEIROERC20, NEO, NEVER, NFAI, NFTB, NOTCOIN, NOW, NPXS, NTVRK, NWC,
    OCEAN, OKB, OMCOIN, OMG, ONE, ONIGIERC20, ONT,
    PEIPEI, PENG, PEW, PIKAETH, PIT, PIVX, PLS, PLX, PONKE, POODL, POOLX, POOLZ, PYUSD,
    QTUM, QUACKBSC, RACA, RAINCOIN, RBIF, REP, RJVBSC, RJVERC20, RUNE, RVN, RXCG,
    SAND, SCRAT, SCRT, SEI, SFUNDBSC, SHIB, SHIBBSC, SIDUS, SNSY, SOL, SOON, SPACEID,
    SPI, SRK, STKK, STPT, STRAX, STRK, SUNCOIN, SUNDOG, SUPERFARM, SXP, SYSEVM,
    TENSHI, TET, TFUEL, THETA, TKO, TLOS, TOMOERC20, TON, TRVL, TRX, TTCBSC, TUP, TUSD, TUSDTRC20,
    UNI, USDC, USDCMATIC, USDCSOL, USDDTRC20, USDE, USDJ, USDP, USDT, USDTBSC, USDTERC20,
    USDTMATIC, USDTSOL, USDTTRC20, UST,
    VELO, VERSE, VET, VIB, VOLT, VPSAI, WABI, WAVES, WBTCMATIC, WIN, WOLF,
    XAUT, XCADERC20, XCUR, XDC, XEC, XEM, XEMPIRE, XLM, XMR, XNO, XRP, XTZ, XVG, XYM,
    XYOERC20, XZC, YFI, ZBCSOL, ZEC, ZEN, ZENT, ZIL, ZKTOKEN, ZROARB, ZROERC,
};
